export * from "./VariableSelect";
import VariableSelect from "./VariableSelect";

export default VariableSelect;
